import { AccountAction, AccountActionTypes } from '../actions/AccountActions';
import { Nullable } from '../types/custom/Nullable';
import { Claims } from '../types/permissions/Claims';

export interface AccountState {
    accessToken: Nullable<string>;
    permissions: Nullable<readonly Claims[]>;
    isAuthenticated: boolean;
    loading: boolean;
    isLoggingOut: boolean;
}

const INITIAL_STATE: AccountState = {
    accessToken: null,
    isAuthenticated: false,
    loading: false,
    permissions: null,
    isLoggingOut: false
};

const account = (state = INITIAL_STATE, action: AccountAction): AccountState => {
    switch (action.type) {
        case AccountActionTypes.ACCOUNT_LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                accessToken: action.payload
            };
        case AccountActionTypes.ACCOUNT_LOGOUT:
            return {
                ...state,
                isLoggingOut: true
            };
        case AccountActionTypes.ACCOUNT_PERMISSIONS_REQUEST_SUCCESS: {
            const permissionsArray: Claims[] = [];
            action.payload.forEach(entity => {
                entity.availableOperations.forEach((ao) => {
                    // There might be a way to avoid cast to 'Claims' here but it's not worth
                    // the time at the moment.
                    permissionsArray.push(`${entity.entityType}:${ao}` as Claims);
                });
            });
            return {
                ...state,
                permissions: permissionsArray
            };
        }
        default:
            return state;
    }
};

export default account;